import { StringDevUIField } from "./StringDevUIField";

export class StringDevFieldColor extends StringDevUIField<string> {
  private colorInput: HTMLInputElement | null = null;
  private hexLabel: HTMLSpanElement | null = null;

  build(): HTMLElement {
    const row = this.createRow();
    row.appendChild(this.createLabel());
    row.appendChild(this.createControl());
    this.root = row;
    return row;
  }

  setValue(value: string): void {
    this.value = value;
    if (this.colorInput) this.colorInput.value = value;
    if (this.hexLabel) this.hexLabel.textContent = value;
  }

  private createControl(): HTMLDivElement {
    const shell = document.createElement("div");
    shell.setAttribute("data-string-dev-color-shell", "");

    const swatchWrap = document.createElement("label");
    swatchWrap.setAttribute("data-string-dev-color-swatch-wrap", "");

    const swatch = document.createElement("span");
    swatch.setAttribute("data-string-dev-color-swatch", "");
    swatch.style.background = this.value;

    const colorInput = document.createElement("input");
    colorInput.type = "color";
    colorInput.value = this.value;
    colorInput.setAttribute("data-string-dev-color-input", "");

    const hexLabel = document.createElement("span");
    hexLabel.setAttribute("data-string-dev-color-value", "");
    hexLabel.textContent = this.value;

    colorInput.addEventListener("input", () => {
      swatch.style.background = colorInput.value;
      hexLabel.textContent = colorInput.value;
      this.emit(colorInput.value);
    });

    this.colorInput = colorInput;
    this.hexLabel = hexLabel;

    swatchWrap.appendChild(swatch);
    shell.appendChild(swatchWrap);
    shell.appendChild(hexLabel);
    shell.appendChild(colorInput);
    return shell;
  }
}
